import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalBody } from 'reactstrap';
import Loading from 'views/Widgets/Loading';

const SubmittingStep: FC = () => (
  <ModalBody className="text-center py-5">
    <Loading />
    <p className="mt-3">
      <FormattedMessage
        id="app.custom_campaign_data.submitting"
        defaultMessage="Uploading data..."
      />
    </p>
  </ModalBody>
);

export default SubmittingStep;
